import { Action } from "@ngrx/store";
import { SlideItem } from '../../models';

export const ADD_ITEM = '[SLIDES] Add Item to Slide Deck';
export const REMOVE_ITEM = '[SLIDES] Remove Item to Slide Deck';

export class AddItem implements Action {
    readonly type = ADD_ITEM;

    constructor(public payload: SlideItem) { }
}

export class RemoveItem implements Action {
    readonly type = REMOVE_ITEM;

    constructor(public payload: SlideItem) { }
}

export type SlidesAction = AddItem | RemoveItem;
